import React from 'react'
import { Outlet } from 'react-router-dom'

const AssistentAdmin = () => {
    return (
      <>
      <Outlet></Outlet>
      </>
    )
}

export default AssistentAdmin